export default __webpack_public_path__ + "static/media/downarrow.e32afd43.svg";